import React from 'react';
import { trans } from '@spotahome/soyuz/client';

import TestimonialQuote from '@components/TestimonialQuote';

import './CardTestimonialQuoteSection.scss';

const quoteList = [
  {
    message: 'home.tenant.testimonial-quote.first-item.quote',
    source: 'home.tenant.testimonial-quote.first-item.quote-source'
  },
  {
    message: 'home.tenant.testimonial-quote.second-item.quote',
    source: 'home.tenant.testimonial-quote.second-item.quote-source'
  },
  {
    message: 'home.tenant.testimonial-quote.third-item.quote',
    source: 'home.tenant.testimonial-quote.third-item.quote-source'
  }
];

const CardTestimonialQuoteSection = () => {
  return (
    <section className="card-testimonial-quote-section">
      <h2 className="card-testimonial-quote-section__title">
        {trans('home.tenant.testimonial-quote.title')}
      </h2>
      <div className="card-testimonial-quote-section__wrapper">
        {quoteList.map(quote => (
          <div className="card-testimonial-quote-section__item">
            <TestimonialQuote
              theme="green"
              key={quote.message}
              message={trans(quote.message)}
              source={trans(quote.source)}
              insideCard
              quoteSize="medium"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default CardTestimonialQuoteSection;
